import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { findMatchedRouteConfig } from 'Lib/utils/linkUtils';
import Routes from 'Routes';

import { setRouteInfo } from 'Store/routing/actions';

const useRouteInfo = ({ loading }: { loading: boolean }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const matchedConfig = findMatchedRouteConfig(location.pathname, Routes);
    const { match } = matchedConfig;
    if (!loading) {
      dispatch(setRouteInfo(match.url, match.params, location));
    }
  }, [location, dispatch, loading]);
};

export default useRouteInfo;
